const STORAGE_KEY = 'kora-consent-confirmation'
export interface StoredConsentConfirmation {
  consentId: string
  token: string
}

/** Capture before auth redirects; the proof must never enter a login return URL. */
export function captureConsentConfirmationFragment(
  path: string = window.location.pathname,
  hash: string = window.location.hash
): void {
  const match = /^\/rights\/consents\/([^/]+)\/confirm$/.exec(path)
  if (!match || !hash) return
  try {
    sessionStorage.removeItem(STORAGE_KEY)
    const token = new URLSearchParams(hash.slice(1)).get('token')
    const consentId = decodeURIComponent(match[1] ?? '')
    if (consentId && token && /^[A-Za-z0-9_-]{43}$/.test(token)) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ consentId, token }))
    }
  } catch {
    // Unavailable storage leaves a missing-link state, with no approval possible.
  } finally {
    window.history.replaceState(window.history.state, '', path + window.location.search)
  }
}

export function readConsentConfirmation(consentId: string): StoredConsentConfirmation | null {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    if (!stored) return null
    const value: unknown = JSON.parse(stored)
    if (
      typeof value !== 'object' ||
      value === null ||
      !('consentId' in value) ||
      !('token' in value)
    )
      return null
    if (
      value.consentId !== consentId ||
      typeof value.token !== 'string' ||
      !/^[A-Za-z0-9_-]{43}$/.test(value.token)
    )
      return null
    return { consentId, token: value.token }
  } catch {
    return null
  }
}
export function clearConsentConfirmation(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* Storage was unavailable. */
  }
}
